// extracted by mini-css-extract-plugin
export default {"quantity_wrapper":"IW","increment":"JW","decrement":"KW","product":"LW","product_info":"MW","text":"NW","modify_btn":"OW","controls":"PW","price":"QW","deliveredOnce":"RW"};
    if(module.hot) {
      // 1711394579785
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  